import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Panel } from 'primereact/panel'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  CustomCardColorBar,
  CustomDropdown,
  PageHeader,
  SectionTitle,
  TextBtn,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useCargasParadasTps, { LOAD_MESSAGE } from './CargasParadasTpsHook'
import * as colors from '../../../../assets/js/colors'
import CustomPieChart from '../../../../components/CustomPieChart/CustomPieChart'
import ModalDataTable from '../../../../components/ModalDataTable/ModalDataTable'
import { tableCellCentered } from '../../../../assets/js/styles'

function CargasParadasTPs({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useCargasParadasTps()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FETCH_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCompaniesGroupAssociatedToUser()
        break

      case LOAD_MESSAGE.GET_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCargasParadasTps(state.companyGroupSelected, selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  return (
    <>
      <PageHeader>1.3 - Cargas Paradas TPs</PageHeader>
      <div style={{ marginTop: 16 }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div className="p-grid p-justify-center">
            <div className="p-grid p-col-12">
              <div className="p-col-4">
                <CustomDropdown
                  showLabel={true}
                  label="Grupo de Empresas"
                  optionLabel={'label'}
                  marginTop={10}
                  options={state.companiesGroups}
                  value={state.companyGroupSelected}
                  onChange={localDispatch.onCompanyGroupChange}
                />
              </div>
              <div className="p-col-fixed">
                <div style={{ marginLeft: 10, paddingTop: 27 }}>
                  <Btn onClick={() => localDispatch.onBtnPesquisar(state.companyGroupSelected)}>
                    Pesquisar
                  </Btn>
                </div>
              </div>
            </div>
            <div className="p-col-12 p-grid">
              <div className="p-col-12">
                <SectionTitle title={'Dados das Cargas Paradas'} />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_cargas_paradas}
                  title={'Cargas Paradas'}
                  subTitle={`em un`}
                  barColor={colors.error}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_qte_sem_motivo}
                  title={'Cargas Paradas sem Motivo'}
                  subTitle={`em un`}
                  barColor={colors.laranja}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_qte_sem_motivo_percent.toFixed(2)}
                  title={'Cargas Paradas sem Motivo'}
                  subTitle={`em %`}
                  barColor={colors.vermelho}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_qte_com_motivo}
                  title={'Cargas Paradas com Motivo'}
                  subTitle={`em un`}
                  barColor={colors.black}
                />
              </div>
              <div className="p-col-12 p-md-8">
                <CustomPieChart
                  title={'Motivos'}
                  items={state.dashboardInfo.motivos_graph_data.cargas_paradas}
                  cellColors={state.cellColors}
                  borderTopColor={colors.azul}
                />
              </div>
            </div>
            <div className="p-grid p-col-12">
              <DataTable
                value={state.dashboardInfo.cargas_paradas}
                style={{
                  textAlign: state.dashboardInfo.cargas_paradas.length > 0 ? 'inherit' : 'center',
                }}
                emptyMessage="Não existem dados para serem exibidos"
                responsive
              >
                <Column field="tp_name" header="Operação" style={tableCellCentered()} />
                <Column
                  field="volume_parado"
                  header="Volume Parado (KG)"
                  style={tableCellCentered(60)}
                />
                <Column
                  field="qte_entregas_paradas"
                  header="Qte Entregas Paradas"
                  style={tableCellCentered(50)}
                />
                <Column
                  field="qte_com_motivo"
                  header="Com Motivo"
                  body={data => (
                    <TextBtn
                      onClick={() => localDispatch.onClickOpenModal('com_motivo', data)}
                      color={colors.azul_escuro}
                    >
                      {data.qte_com_motivo}
                    </TextBtn>
                  )}
                  style={tableCellCentered(50)}
                />
                <Column
                  field="qte_sem_motivo"
                  header="Sem Motivo"
                  body={data => (
                    <TextBtn
                      onClick={() => localDispatch.onClickOpenModal('sem_motivo', data)}
                      color={colors.azul_escuro}
                    >
                      {data.qte_sem_motivo}
                    </TextBtn>
                  )}
                  style={tableCellCentered(50)}
                />
                <Column
                  field="maximo_atraso"
                  header="Maximo Atraso"
                  style={tableCellCentered(50)}
                />
              </DataTable>
            </div>
          </div>
        </Panel>
        <ModalDataTable
          fields={state.modalInfo.fields}
          data={state.modalInfo.data}
          onClose={localDispatch.onModalClose}
          title={state.modalInfo.title}
          show={state.modalInfo.show}
          width={state.modalInfo.width}
          fieldParser={state.modalInfo.fieldParser}
          expander={state.modalInfo.expander}
          expanderTemplate={state.modalInfo.expanderTemplate}
          rowExpansionTemplate={rowExpansionTemplate}
          expanderDataKey={'identificador'}
          expanderTemplateColumn={'cliente'}
        />
      </div>
    </>
  )
}

const rowExpansionTemplate = data => {
  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12 p-md-9">
        <div className="p-grid">
          <div className="p-md-2">Nome: </div>
          <div className="p-md-10" style={{ fontWeight: 'bold' }}>
            {data.cliente}
          </div>

          <div className="p-md-2">Cidade: </div>
          <div className="p-md-10" style={{ fontWeight: 'bold' }}>
            {data.cidade}
          </div>

          <div className="p-md-2">Bairro: </div>
          <div className="p-md-10" style={{ fontWeight: 'bold' }}>
            {data.bairro}
          </div>

          <div className="p-md-2">CNPJ: </div>
          <div className="p-md-10" style={{ fontWeight: 'bold' }}>
            {data.cnpj}
          </div>
          <div className="p-md-2">Qte. Caixas: </div>
          <div className="p-md-10" style={{ fontWeight: 'bold' }}>
            {data.qte_caixas}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapToProps = ({
  dashboard: {
    statusOperacoes: { status, pInicial, pFinal },
  },
  system: { selectedTp },
}) => ({ status, pInicial, pFinal, selectedTp })
export default connect(mapToProps)(withRouter(CargasParadasTPs))
